import { useContext } from 'react';

import { TextField } from '@atom/mui';

import CreateAssetModalContext from './CreateAssetModalContext';

import classes from './createAssetModal.module.css';

const styles = {
  input: {
    marginTop: '1rem',
  },
};

const NameTab = () => {
  const { name, setName, disableName } = useContext(CreateAssetModalContext);

  return (
    <div className={classes.tabContainer}>
      <div className={classes.tabTitle}>Name</div>
      <TextField
        style={styles.input}
        placeholder="Enter Inventory Name"
        value={name}
        onChange={event => setName(event?.target?.value)}
        variant="standard"
        disabled={disableName}
        data-cy="globalCreateAssetModalNameInput"
      />
    </div>
  );
};

export default NameTab;
